// frontend/src/components/ForgotPassword.js
import React, { useState } from 'react';
import axios from 'axios';
import './Auth.css';
import API_URL from '../config';

const ForgotPassword = ({ onBack }) => {
  const [step, setStep] = useState(1); // 1: email, 2: código y nueva contraseña
  const [email, setEmail] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [generatedCode, setGeneratedCode] = useState(''); // Solo para desarrollo

  const handleRequestCode = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setSuccess('Código de recuperación enviado. Revisa la consola del navegador (F12).');
      setGeneratedCode(response.data.resetCode); // Solo para desarrollo
      console.log('Código de recuperación:', response.data.resetCode);
      setStep(2);
    } catch (err) {
      setError(err.response?.data?.message || 'Error al solicitar código');
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }

    if (newPassword.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    setLoading(true);

    try {
      await axios.post(`${API_URL}/api/auth/reset-password`, {
        email,
        resetCode,
        newPassword,
      });
      setSuccess('¡Contraseña actualizada exitosamente! Redirigiendo al login...');
      setTimeout(() => {
        onBack();
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || 'Error al restablecer contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Recuperar Contraseña</h2>

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        {step === 1 ? (
          <form onSubmit={handleRequestCode}>
            <p className="help-text">
              Ingresa tu email y te enviaremos un código de recuperación.
            </p>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="tu@email.com"
              />
            </div>
            <button type="submit" className="auth-btn" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar Código'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleResetPassword}>
            {generatedCode && (
              <div className="code-display">
                <strong>Código generado (solo desarrollo):</strong> {generatedCode}
              </div>
            )}
            <div className="form-group">
              <label>Código de recuperación</label>
              <input
                type="text"
                value={resetCode}
                onChange={(e) => setResetCode(e.target.value)}
                required
                placeholder="123456"
                maxLength={6}
              />
            </div>
            <div className="form-group">
              <label>Nueva contraseña</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                minLength={6}
                placeholder="••••••••"
              />
            </div>
            <div className="form-group">
              <label>Confirmar nueva contraseña</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="••••••••"
              />
            </div>
            <button type="submit" className="auth-btn" disabled={loading}>
              {loading ? 'Actualizando...' : 'Actualizar Contraseña'}
            </button>
          </form>
        )}

        <p className="auth-switch">
          <span onClick={onBack}>Volver al login</span>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;